import React from 'react';
import { Table as AntTable, Empty } from 'antd-v5';
import emptyImg from '@/common/images/empty.png';
import { withDefaultShowTotal } from '@/utils/pagination';
import './style.less';
function Table(props) {
  const { size = 'middle', pagination = {}, ...nativeProps } = props;

  return (
    <AntTable
      {...nativeProps}
      className='ui-table'
      size={size}
      pagination={
        pagination === false
          ? false
          : withDefaultShowTotal({
              showSizeChanger: false,
              size: 'default',
              ...pagination,
            })
      }
      locale={{
        emptyText: (
          <Empty
            image={emptyImg}
            imageStyle={{
              height: 124,
              marginBottom: -8,
            }}
            description={
              <span style={{ color: '#A6A6A6', fontSize: 14, fontWeight: 400 }}>暂无数据</span>
            }
          />
        ),
      }}
    />
  );
}
export default Table;
